import { render } from "./MultiTopicView.vue?vue&type=template&id=1a6bd864&scoped=true"
import script from "./MultiTopicView.vue?vue&type=script&lang=js"
export * from "./MultiTopicView.vue?vue&type=script&lang=js"

import "./MultiTopicView.vue?vue&type=style&index=0&id=1a6bd864&scoped=true&lang=css"
import "./MultiTopicView.vue?vue&type=style&index=1&id=1a6bd864&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a6bd864"]])

export default __exports__